// eslint-disable-next-line import/no-cycle
import { navbarStateVar } from '@store/reactiveVars';

export interface INavBarQuery {
  query: string;
  bookmarks?: string[];
  suggestions?: string[];
}

export const navbarQueryState: INavBarQuery = {
  query: ''
  // bookmarks: [],
  // suggestions: [],
};

export const handleSearchQuery = (payload: string) => {
  const state = navbarStateVar();
  state.query = payload;
  navbarStateVar(state);
};
